export default __webpack_public_path__ + "static/icon_quote-e490d4f095840e270a3762102a5ce4c1.png";